module.exports = __webpack_public_path__ + "img/DAY3-1.466301c3.jpg";